export default "__VITE_ASSET__AkQb1nDH__"